export function isDbChatTone(tone) {
    return "tenant_id" in tone;
}
